/* The stain guide's drawings. Written by dev/np-sync.mjs from design/pages/src/_stainart.cjs: edit it there. */
(function () {
var module = { exports: {} };
// The stain guide's drawings (proposal, 2026-10-20), made by build.cjs:
//   swatch(): a piece of fabric cut with pinking shears (its edges zig-zag): white cotton, grey jersey, khaki or dark jersey, with
//     the stain on it in its own colour and shape; on a stain's own page a drop of it falls onto the fabric first
//   shirt(): the guide's first screen, a T-shirt that three drops fall onto (coffee, wine, oil), each leaving its stain
//   card(): a stain's card in the guide and under «Παρόμοιοι λεκέδες»
// Every shape comes from the stain's own name (a seeded random), so it is the same on every build.
const r1 = (v) => Math.round(v * 10) / 10;
const TAU = Math.PI * 2;

function rng(name) {
  let h = 2166136261;
  for (let i = 0; i < name.length; i++) { h ^= name.charCodeAt(i); h = Math.imul(h, 16777619); }
  let a = h >>> 0;
  return function () {
    a = (a + 0x6D2B79F5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// a soft blob through n points around (cx, cy): radius r, wobbling by wob, stretched by sx/sy and turned by rot
function blob(cx, cy, r, rnd, o) {
  o = o || {};
  const n = o.n || 10, wob = o.wob == null ? 0.18 : o.wob, sx = o.sx || 1, sy = o.sy || 1, rot = o.rot || 0;
  const k1 = 2 + Math.floor(rnd() * 2), k2 = 3 + Math.floor(rnd() * 3), p1 = rnd() * TAU, p2 = rnd() * TAU;
  const c = Math.cos(rot), s = Math.sin(rot), pts = [];
  for (let i = 0; i < n; i++) {
    const a = i / n * TAU;
    const rr = r * (1 + wob * (0.55 * Math.sin(k1 * a + p1) + 0.45 * Math.sin(k2 * a + p2)) + wob * 0.4 * (rnd() - 0.5));
    const x = Math.cos(a) * rr * sx, y = Math.sin(a) * rr * sy;
    pts.push([cx + x * c - y * s, cy + x * s + y * c]);
  }
  let d = 'M' + r1(pts[0][0]) + ' ' + r1(pts[0][1]);
  for (let i = 0; i < n; i++) {
    const p0 = pts[(i + n - 1) % n], q1 = pts[i], q2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
    d += 'C' + r1(q1[0] + (q2[0] - p0[0]) / 6) + ' ' + r1(q1[1] + (q2[1] - p0[1]) / 6) + ' ' +
      r1(q2[0] - (p3[0] - q1[0]) / 6) + ' ' + r1(q2[1] - (p3[1] - q1[1]) / 6) + ' ' + r1(q2[0]) + ' ' + r1(q2[1]);
  }
  return d + 'Z';
}

// the fabric: a square of W cut with pinking shears, N teeth a side
function pinked(W, N, d) {
  const st = W / N, p = [];
  for (let i = 0; i <= N; i++) p.push([i * st, i % 2 ? d : 0]);
  for (let i = 1; i <= N; i++) p.push([W - (i % 2 ? d : 0), i * st]);
  for (let i = 1; i <= N; i++) p.push([W - i * st, W - (i % 2 ? d : 0)]);
  for (let i = 1; i < N; i++) p.push([i % 2 ? d : 0, W - i * st]);
  return 'M' + p.map((q) => r1(q[0]) + ' ' + r1(q[1])).join('L') + 'Z';
}
const PINK = pinked(120, 16, 2.6);
const FAB = {
  white: { base: '#FFFFFF', pat: 'lkweave', edge: 'rgba(11,33,84,.16)' },
  grey: { base: '#D9DCE1', pat: 'lkknitd', edge: '' },
  khaki: { base: '#CDBF9F', pat: 'lktwill', edge: '' },
  dark: { base: '#1D2331', pat: 'lkknit', edge: '' }
};
// the shapes a drop leaves (a drop falls first on a stain's page); the others wipe on, sweat comes up slowly
const DROPPED = { splash: 1, ring: 1, spatter: 1 };
const KIND = { splash: 'grow', ring: 'grow', spatter: 'grow', halo: 'halo', smear: 'wipe', streaks: 'wipe', line: 'wipe', marks: 'wipe' };

// the stain itself around (cx, cy) at scale s; id: for its own gradient. Returns its drawing, where a drop lands and
// where it grows from
function shapes(L, rnd, cx, cy, s, id) {
  const col = L.col, out = { defs: '', svg: '', x: cx, y: cy, ox: cx, oy: cy };
  const fill = (d, op, edge) => '<path d="' + d + '" fill="' + col + '" fill-opacity="' + op + '"' +
    (edge ? ' stroke="' + col + '" stroke-opacity="' + edge + '" stroke-width="' + r1(1.3 * s) + '"' : '') + '/>';
  const dx = (rnd() - 0.5) * 10 * s, dy = (rnd() - 0.5) * 8 * s;
  if (L.type === 'splash') {
    const x = cx + dx, y = cy + dy;
    out.svg += fill(blob(x, y, 23 * s, rnd, { n: 11, wob: 0.22 }), 0.82, 0.9);
    for (let i = 0; i < 6; i++) {
      const a = rnd() * TAU, dist = (33 + rnd() * 13) * s, r = (1.8 + rnd() * 3.4) * s;
      out.svg += fill(blob(x + Math.cos(a) * dist, y + Math.sin(a) * dist, r, rnd, { n: 7, wob: 0.25 }), 0.85, 0);
    }
    out.x = out.ox = x; out.y = out.oy = y;
  } else if (L.type === 'ring') {
    const x = cx + dx, y = cy + dy;
    out.svg += fill(blob(x, y, 22 * s, rnd, { n: 12, wob: 0.1 }), 0.34, 0.75).replace('stroke-width="' + r1(1.3 * s) + '"', 'stroke-width="' + r1(2.4 * s) + '"');
    out.svg += fill(blob(x - 2 * s, y + 1 * s, 13 * s, rnd, { n: 9, wob: 0.14 }), 0.22, 0);
    out.x = out.ox = x; out.y = out.oy = y;
  } else if (L.type === 'spatter') {
    const x = cx + dx, y = cy + dy;
    out.svg += fill(blob(x, y, 16 * s, rnd, { n: 10, wob: 0.3 }), 0.9, 0.6);
    for (let i = 0; i < 9; i++) {
      const a = rnd() * TAU, dist = (14 + rnd() * 34) * s, r = (2.4 + rnd() * 6) * s;
      out.svg += fill(blob(x + Math.cos(a) * dist, y + Math.sin(a) * dist, r, rnd, { n: 8, wob: 0.32 }), r1(0.62 + rnd() * 0.3), 0);
    }
    out.x = out.ox = x; out.y = out.oy = y;
  } else if (L.type === 'halo') {
    const g = 'lkh-' + id;
    out.defs += '<radialGradient id="' + g + '"><stop offset="0" stop-color="' + col + '" stop-opacity=".55"/><stop offset=".75" stop-color="' + col + '" stop-opacity=".3"/><stop offset="1" stop-color="' + col + '" stop-opacity=".12"/></radialGradient>';
    out.svg += '<path d="' + blob(cx, cy + 2 * s, 31 * s, rnd, { n: 12, wob: 0.09, sx: 1.22, sy: 0.92 }) + '" fill="url(#' + g + ')" stroke="' + col + '" stroke-opacity=".5" stroke-width="' + r1(1.8 * s) + '"/>';
    out.svg += '<path d="' + blob(cx + 4 * s, cy, 18 * s, rnd, { n: 10, wob: 0.12, sx: 1.2, sy: 0.9 }) + '" fill="' + col + '" fill-opacity=".14"/>';
  } else if (L.type === 'smear') {
    const rot = -0.42, ux = Math.cos(rot), uy = Math.sin(rot), x = cx - 16 * s * ux, y = cy - 16 * s * uy;
    out.svg += fill(blob(x, y, 17 * s, rnd, { n: 11, wob: 0.16, sx: 1.6, sy: 0.82, rot }), 0.84, 0.85);
    out.svg += fill(blob(x + 30 * s * ux, y + 30 * s * uy, 10 * s, rnd, { n: 9, wob: 0.18, sx: 2.3, sy: 0.5, rot }), 0.62, 0);
    out.svg += fill(blob(x + 50 * s * ux, y + 50 * s * uy, 6 * s, rnd, { n: 8, wob: 0.2, sx: 2.4, sy: 0.45, rot }), 0.36, 0);
    out.ox = x - 28 * s * ux; out.oy = y - 28 * s * uy;
  } else if (L.type === 'streaks') {
    const rot = -0.55, ux = Math.cos(rot), uy = Math.sin(rot), nx = -uy, ny = ux;
    for (let i = 0; i < 4; i++) {
      const off = (-16 + 10.5 * i) * s, along = (rnd() - 0.5) * 16 * s, r = (10 + rnd() * 4) * s;
      out.svg += fill(blob(cx + nx * off + ux * along, cy + ny * off + uy * along, r, rnd, { n: 10, wob: 0.16, sx: 3.2, sy: 0.3, rot: rot + (rnd() - 0.5) * 0.12 }), r1(0.55 + rnd() * 0.3), 0);
    }
    out.ox = cx - 46 * s * ux; out.oy = cy - 46 * s * uy;
  } else if (L.type === 'line') {
    const x = cx - 14 * s, y = cy + 13 * s, P = (a, b) => r1(cx + a * s) + ' ' + r1(cy + b * s);
    out.svg += '<path d="' + blob(x, y, 17 * s, rnd, { n: 10, wob: 0.2 }) + '" fill="' + col + '" fill-opacity=".2"/>';
    out.svg += fill(blob(x, y, 10 * s, rnd, { n: 10, wob: 0.22 }), 0.85, 0.9);
    out.svg += '<path d="M' + P(-12, 9) + 'C' + P(-4, -2) + ' ' + P(0, 20) + ' ' + P(8, 6) + 'C' + P(15, -6) + ' ' + P(20, 10) + ' ' + P(27, -4) + 'C' + P(31, -12) + ' ' + P(34, -18) + ' ' + P(39, -24) +
      '" fill="none" stroke="' + col + '" stroke-opacity=".9" stroke-width="' + r1(2.6 * s) + '" stroke-linecap="round"/>';
    out.ox = x - 18 * s; out.oy = y;
  } else if (L.type === 'marks') {
    const rot = 0.38;
    for (let i = 0; i < 3; i++) {
      const off = (-15 + 14 * i) * s, along = (rnd() - 0.5) * 12 * s, r = (11 + rnd() * 3) * s;
      out.svg += fill(blob(cx - Math.sin(rot) * off + Math.cos(rot) * along, cy + Math.cos(rot) * off + Math.sin(rot) * along, r, rnd, { n: 10, wob: 0.2, sx: 2.6, sy: 0.42, rot: rot + (rnd() - 0.5) * 0.15 }), r1(0.5 + rnd() * 0.2), 0);
    }
    out.ox = cx - 40 * s; out.oy = cy - 15 * s;
  } else throw new Error('no stain shape ' + L.type);
  return out;
}

// a drop of the stain's own colour, the brand's drop falling head first; its head lands on (x, y)
function drop(col, x, y, w, fall, t) {
  const k = w / 24;
  return '<g class="lkd" style="--t:' + t + ';--fall:' + fall + 'px"><use href="#lkdrop" x="' + r1(x - 11.6 * k) + '" y="' + r1(y - 15.6 * k) + '" width="' + r1(w) + '" height="' + r1(w) +
    '" transform="rotate(-16 ' + r1(x) + ' ' + r1(y) + ')" style="color:' + col + '"/></g>';
}

// v: 'c' on a card, 'h' in a stain's first screen (where it plays: a drop falls, then the stain grows or wipes on)
function swatch(s, v) {
  const L = s.look, fab = FAB[L.fab], rnd = rng(s.slug), id = s.slug + '-' + v, big = v === 'h';
  const sh = shapes(L, rnd, 60, 60, 1, id), kind = KIND[L.type], dropped = big && DROPPED[L.type];
  const g = big ? ' class="lkst lkst--' + kind + '" style="transform-origin:' + r1(sh.ox) + 'px ' + r1(sh.oy) + 'px;--g:' + (dropped ? '.78s' : '.3s') + '"' : '';
  return '<svg class="lksw' + (big ? ' lksw--big' : '') + '" viewBox="0 0 120 120" aria-hidden="true" focusable="false">' +
    (sh.defs ? '<defs>' + sh.defs + '</defs>' : '') +
    '<path d="' + PINK + '" fill="' + fab.base + '"/><path d="' + PINK + '" fill="url(#' + fab.pat + ')"/>' +
    '<g clip-path="url(#lkclip)"><g' + g + '>' + sh.svg + '</g></g>' +
    '<path d="' + PINK + '" fill="url(#lkshade)"/>' + (fab.edge ? '<path d="' + PINK + '" fill="none" stroke="' + fab.edge + '"/>' : '') +
    (dropped ? drop(L.col, sh.x, sh.y, 15, -110, '.18s') : '') + '</svg>';
}

function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

// a stain's card: its fabric on a light table, a little turned, its name and the one thing to remember; the guide's
// search reads data-k
function card(s) {
  const tilt = r1((rng(s.slug + '-tilt')() - 0.5) * 9);
  return '<li data-c="' + s.cats.join(' ') + '" data-k="' + esc(s.k) + '" data-col="' + s.look.col + '" style="--stain:' + s.look.col + '"><a class="lkcard" href="lekes-' + s.slug + '.html">' +
    '<span class="lkcard__pic" style="--tilt:' + tilt + 'deg">' + swatch(s, 'c') + '</span><span class="lkcard__t"><b>' + s.name + '</b><span>' + s.tip + '</span></span></a></li>';
}

// what every stain page and the guide share: the fabrics' weaves, the light on them, the pinked edge and the drop
function defs(dropPath) {
  return '<svg class="lkdefs" width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false"><defs>' +
    '<pattern id="lkweave" width="2" height="2" patternUnits="userSpaceOnUse"><path d="M0 .5H2M.5 0V2" stroke="#0B2154" stroke-opacity=".045" stroke-width=".6"/></pattern>' +
    '<pattern id="lktwill" width="3" height="3" patternUnits="userSpaceOnUse" patternTransform="rotate(-35)"><path d="M0 .75H3" stroke="#fff" stroke-opacity=".16" stroke-width=".8"/><path d="M0 2.25H3" stroke="#0B2154" stroke-opacity=".1" stroke-width=".5"/></pattern>' +
    '<pattern id="lkknit" width="5" height="4" patternUnits="userSpaceOnUse"><path d="M0 2L1.25 .5 2.5 2 3.75 .5 5 2" fill="none" stroke="#fff" stroke-opacity=".07"/></pattern>' +
    '<pattern id="lkknitd" width="3" height="2.4" patternUnits="userSpaceOnUse"><path d="M0 1.2L.75 .3 1.5 1.2 2.25 .3 3 1.2" fill="none" stroke="#1A1C20" stroke-opacity=".07" stroke-width=".6"/></pattern>' +
    '<radialGradient id="lkshade" cx=".5" cy=".42" r=".75"><stop offset=".55" stop-color="#0B2154" stop-opacity="0"/><stop offset="1" stop-color="#0B2154" stop-opacity=".1"/></radialGradient>' +
    '<clipPath id="lkclip"><path d="' + PINK + '"/></clipPath>' +
    '<symbol id="lkdrop" viewBox="0 0 24 24"><path d="' + dropPath + '" fill="currentColor"/><ellipse cx="9.2" cy="12.9" rx="1.6" ry="1" fill="#fff" opacity=".5" transform="rotate(-50 9.2 12.9)"/></symbol>' +
    '</defs></svg>';
}

// The guide's first screen: a T-shirt in the drawings' lines; a drop of coffee, then wine, then oil falls onto it and
// leaves its stain, and each stain gets its name. w: the words, for a page in another language ({ kafes, krasi, ladi,
// label }; Greek when left out); a label grows with a longer word
const SHIRT = 'M160 58C172 84 228 84 240 58L292 72L352 122L322 172L284 150V372Q284 378 278 378H122Q116 378 116 372V150L78 172L48 122L108 72Z';
function shirt(bySlug, w) {
  w = w || {};
  const spots = [
    { s: bySlug.kafes, x: 168, y: 170, k: 0.78, t: 0.25, lab: { x: 8, y: 186, w: 86, side: -1, ax: 150, ay: 174 }, word: w.kafes || 'καφές' },
    { s: bySlug.krasi, x: 236, y: 244, k: 0.9, t: 0.9, lab: { x: 306, y: 262, w: 86, side: 1, ax: 260, ay: 252 }, word: w.krasi || 'κρασί' },
    { s: bySlug.ladi, x: 172, y: 312, k: 0.74, t: 1.55, lab: { x: 14, y: 320, w: 76, side: -1, ax: 156, ay: 314 }, word: w.ladi || 'λάδι' }
  ];
  let stains = '', drops = '', labels = '';
  spots.forEach((p, i) => {
    const sh = shapes(p.s.look, rng(p.s.slug + '-shirt'), p.x, p.y, p.k, 'shirt' + i);
    stains += '<g class="lkst lkst--grow" style="transform-origin:' + r1(sh.ox) + 'px ' + r1(sh.oy) + 'px;--g:' + r1(p.t + 0.6) + 's">' + sh.svg + '</g>';
    drops += drop(p.s.look.col, sh.x, sh.y, 26, -(sh.y + 70), p.t + 's');
    const L = p.lab, lw = Math.max(L.w, Math.round(40 + p.word.length * 8.6)), ey = L.y + 14, ex = L.side < 0 ? L.x + lw : L.x;
    labels += '<g class="lklab" style="--t:' + r1(2.3 + i * 0.16) + 's"><path class="lklab__ln" d="M' + ex + ' ' + ey + 'L' + L.ax + ' ' + L.ay + '" pathLength="1"/>' +
      '<rect x="' + L.x + '" y="' + L.y + '" width="' + lw + '" height="28" rx="14"/><circle cx="' + (L.x + 16) + '" cy="' + ey + '" r="5" fill="' + p.s.look.col + '"/>' +
      '<text x="' + (L.x + 28) + '" y="' + (ey + 5) + '">' + esc(p.word) + '</text></g>';
  });
  return '<svg class="lkshirt" viewBox="0 0 400 420" role="img" aria-label="' + esc(w.label || 'Ένα λευκό μπλουζάκι με λεκέδες από καφέ, κρασί και λάδι') + '" focusable="false">' +
    '<defs><clipPath id="lkshirtclip"><path d="' + SHIRT + '"/></clipPath></defs>' +
    '<path class="lkshirt__body" d="' + SHIRT + '"/>' +
    '<g clip-path="url(#lkshirtclip)">' + stains + '</g>' +
    '<path class="lkshirt__ln" d="M166 61C178 92 222 92 234 61M55.7 117.4L85.7 167.4M344.3 117.4L314.3 167.4M116 362H284"/>' +
    '<path class="lkshirt__edge" d="' + SHIRT + '"/>' + drops + labels + '</svg>';
}

module.exports = { swatch, card, shirt, defs, rng };
window.NPArt = module.exports;
})();
